import agent from './agent'
import dashboard from './dashboard'
import detect from './detect'
import forgery from './forgery'
import forgerydetect from './forgerydetect'
import pattern from './pattern'
import report from './report'
import result from './result'
import hash from './hash'

const wsfinder_v2 = {
  agent, dashboard, detect, forgery, forgerydetect, pattern, report, result, hash
}

export default wsfinder_v2

export { agent, dashboard, detect, forgery, forgerydetect, pattern, report, result, hash }